import { STORAGE_KEYS } from './constants';

/**
 * Logged-in user email from localStorage
 */
export function readLoggedInUserEmailFromStorage(): string {
  return (
    emailFromUserJsonString(localStorage.getItem(STORAGE_KEYS.USER_PROFILE_CACHE)) ||
    emailFromUserJsonString(localStorage.getItem(STORAGE_KEYS.USER_DETAILS))
  );
}

function emailFromUserJsonString(raw: string | null): string {
  const text = raw?.trim() ?? '';
  if (!text) {
    return '';
  }
  const email = tryReadEmailFromUserJson(text);
  return email ?? '';
}

function tryReadEmailFromUserJson(text: string): string | null {
  try {
    const root = JSON.parse(text);
    if (typeof root !== 'object' || root === null || Array.isArray(root)) {
      return null;
    }
    const candidate = root as UserEmailJsonField;
    const email = candidate.email;
    return typeof email === 'string' ? email.trim() : null;
  } catch {
    return null;
  }
}

interface UserEmailJsonField {
  email?: string | number | boolean | null;
}
